export const DynamicListsFeature = 'business_app_dynamic_lists';
export const EphemeralAutomationsFeature = 'ephemeral_automations';
export const SendEmailFeature = 'crm_send_email';
export const CampaignsProDemo = 'MP-WF5KS7FHTGV4LR5DBQ4D6XKCCDB5B6G7';
export const CampaignsProProd = 'MP-ZGJ6V4QRP77WPMDKXS6VDRNX58Q42P7P';
